// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__QaUAv","label":"Labeled_label__-Jsla","divider":"Labeled_divider__1s-5j"};